import { createFileRoute, stripSearchParams } from '@tanstack/react-router'

import { CustomerListPage } from '@/features/customers/components/customer-list-page'
import { CUSTOMERS_SEARCH_DEFAULTS, customersSearchSchema } from '@/features/customers/search-schema'

/**
 * /customers —— 客户列表。
 *
 * 筛选 / 排序 / 分页全部走 search params(zod 校验,非法值降级而不是白屏),
 * 等于默认值的参数由 stripSearchParams 从 URL 里摘掉,裸 /customers 就是干净首屏。
 * 页面实现见 features/customers/。
 */
export const Route = createFileRoute('/_authed/customers/')({
  validateSearch: customersSearchSchema,
  search: {
    middlewares: [stripSearchParams(CUSTOMERS_SEARCH_DEFAULTS)],
  },
  component: CustomerListPage,
})
